// TODO: statusの絞り込みにも使うので名前を変える
export class CategoryModalView {
  constructor(rootElement = document) {
    this.$modal = rootElement.querySelector('.js-category-modal');
    if (!this.$modal) return;

    this.$openButton = rootElement.querySelector('.js-open-category-modal');
    this.$closeButton = this.$modal.querySelector('.close');

    this.$openButton.addEventListener('click', () => this.show());
    this.$closeButton.addEventListener('click', () => this.hide());
  }

  show() {
    this.$modal.classList.add('isOpen');
  }

  hide() {
    this.$modal.classList.remove('isOpen');
  }
}
